import React, { useState, useEffect, useRef, useCallback } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../App.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchClientData } from "../redux/client/clientSlice";
import socket from "../context/socket";
import _ from "lodash";
import { Link } from "react-router-dom";
import { IoIosLogOut } from "react-icons/io";
import { FaPowerOff, FaRegCalendarAlt } from "react-icons/fa";
import FullCalendar from '@fullcalendar/react'
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import { fetchCalendarMeetings } from "../redux/client/calendarSlice";
import CalendarView from "./CalendarView";
import dayjs from 'dayjs';
import { useScrollSync } from "../Components/useScrollSync";



const Navbar = ({ isConnected, isDarkMode, setIsDarkMode }) => {
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const calendarRef = useRef(null);
  const [socketConnected, setSocketConnected] = useState(isConnected);
  const dispatch = useDispatch();
  const roomId = new URLSearchParams(window.location.search).get("clientId");

  const [isCOBStopped, setCOBStopped] = useState(false);
  useScrollSync("advisor");

  // useEffect(() => {
  //   if (calendarRef.current && fromDate) {
  //     calendarRef.current.getApi().gotoDate(fromDate);
  //   }
  // }, [fromDate]);

  // useEffect(() => {
  //   console.log("kkk");

  //   dispatch(fetchClientData(roomId));
  // }, [dispatch, roomId]);

  //   useEffect(()=>{
  // socket.emit("message ",{isCOBStopped})
  // console.log("emitdata")
  // ,[isCOBStopped]})


  const { clientData } = useSelector((state) => state.client);


  // socket.on("end_session", ({ clientId }) => {
  //   if (clientId) {
  //     activeSessions.delete(clientId);
  //     io.to(clientId.toString()).emit("force_disconnect", {
  //       message: "Advisor ended the session.",
  //     });
  //   }
  // });



  // console.log('clientData', clientData);

  // Joining socket room
  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      socket.emit("message", {
        room: roomId,
        data: {
          isCOBStopped,
        },
      });

      // console.log("datais", isCOBStopped);
    }, 300),
    [isCOBStopped]
  );

  useEffect(() => {
    debouncedEmitMessage();
  }, [isCOBStopped]);

  useEffect(() => {
    const viewMode = getCookie("view_mode");
    if (viewMode === "1") {
      setIsDarkMode(true);
      document.body.classList.add("dark-mode");
    }
  }, []);

  const handleToggleChange = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    document.body.classList.toggle("dark-mode", newMode);
    setCookie("view_mode", newMode ? "1" : "-1", 1);
  };

  const handleSocketToggle = () => {
    setCOBStopped(true);
    setTimeout(() => {
      if (socketConnected) {
        socket.disconnect();
      }
      setSocketConnected(!socketConnected);
    }, 1000);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    console.log("Selected Date:", date);
    setShowCalendar(false);
  };

  const { meetings, loading, error } = useSelector((state) => state.calendar);
  // console.log("📅 Calendar response:", meetings);


  const toggleCalendar = async (event) => {
    event.stopPropagation();
    setShowCalendar((prev) => {
      const nextState = !prev;

      if (nextState && clientData?.advisor_id) {
        // const fromDate = dayjs().startOf('week').format('YYYY-MM-DD');
        // const toDate = dayjs().endOf('week').format('YYYY-MM-DD');
        const today = dayjs().format('YYYY-MM-DD');


        dispatch(fetchCalendarMeetings({
          advisorId: clientData.advisor_id,
          fromDate: today,
          toDate: today,
        }));
      }

      return nextState;
    });
  };

  const handleDatesSet = (arg) => {
    const from = dayjs(arg.startStr).format('YYYY-MM-DD');
    const to = new Date(arg.endStr).toISOString().split('T')[0];
    // const todayStart = dayjs().startOf('day').toISOString();
    // const todayEnd = dayjs().endOf('day').toISOString();

    // const today = dayjs().format('YYYY-MM-DD');
    // console.log('🗓 View Changed:', from, to);

    // Send only date without time+offset
    dispatch(fetchCalendarMeetings({
      advisorId: clientData.advisor_id,
      fromDate: from,
      toDate: to,
    }));
  }



  const handleClickOutside = (event) => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setShowCalendar(false);
    }
  };

  useEffect(() => {
    if (showCalendar) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => document.removeEventListener("click", handleClickOutside);
  }, [showCalendar]);

  const handleLogout = () => {
    socket.emit("end_session", { clientId: roomId });
    localStorage.removeItem("admin");
    localStorage.removeItem("authToken");
    localStorage.removeItem("user_ip");


    // window.location.href = "https://www.finedge.in/";
    window.location.href = "https://crm.finedge.in/?logout=true";
  };



  const formattedEvents = meetings.map(event => ({
    title: event.title,
    start: event.startTime,
    end: event.endTime,
    extendedProps: {
      clientName: event.clientName,
      eventColor: event.eventColor,
    }
  }))

  return (
    <>
      <header>
        <nav className="navbar navbar-expand-lg border-bottom">
          <div className="container">
            <Link
              className="navbar-brand text-white"
              to={"https://www.finedge.in/"}
            >
              <img src="/assets/images/logo-1.svg" alt="logo" />
            </Link>

            {/* <div className="col-6 col-lg-3 mb-2 d-flex justify-content-end justify-content-md-end align-items-center">
                {socketConnected ? (
                  <button
                    className="back-clrgreen minibtn w-50 w-md-auto"
                    onClick={handleSocketToggle}
                  >
                    Stop Co-Browsing
                  </button>
                ) : (
                  <span className="fs-12 clrgreen">Co-Browsing Stopped</span>
                )}
              </div> */}

            <div className="d-flex gap-2 align-items-center d-lg-none">
              <label className="switch">
                <input
                  type="checkbox"
                  className="toggle"
                  id="toggle_mode"
                  checked={isDarkMode}
                  onChange={handleToggleChange}
                />
                <span className="slider round"></span>
              </label>
              <div className="d-flex align-items-center ms-auto gap-2">

                <div className="user-circle " onClick={toggleCalendar}>
                  <FaRegCalendarAlt />
                </div>

                {/* <div className="user-circle ">
                  {clientData.firstName?.[0] || "?"}
                </div> */}
                <div className="user-circle  text-danger border-danger spacehead clr  " type="button"
                  title="Logout"
                  onClick={handleLogout}
                  style={{ cursor: "pointer" }}
                >

                  <FaPowerOff />

                </div>
              </div>

            </div>

            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                <li className="nav-item p-4 d-none d-md-block">
                  <div
                    className={`connection-status ${isConnected ? "connected" : "disconnected"
                      }`}
                  >
                    <div className="status-indicator"></div>&nbsp;
                    <p className="mt-3">
                      {isConnected
                        ? "Client Online"
                        : "Client Offline"}
                    </p>
                  </div>

                  {/* <div
  className={`connection-status ${
    isConnected ? "connected" : "disconnected"
  }`}
>
  <div className="status-indicator"></div>
  <p className="mt-3 mb-0">
    {isConnected ? "Client Online" : "Client Offline"}
  </p>
</div> */}
                </li>
                <li className="nav-item pt-3">
                  <label className="switch">
                    <input
                      type="checkbox"
                      className="toggle"
                      id="toggle_mode"
                      checked={isDarkMode}
                      onChange={handleToggleChange}
                    />
                    <span className="slider round"></span>
                  </label>
                </li>
                <li className="nav-item d-none d-md-block">
                  <a className="nav-link text-white" href="#">
                    <img
                      src="/assets/images/calender.svg"
                      alt="calendar"
                      onClick={toggleCalendar}
                      className="calendar-icon desktop"
                      width={"52px"}
                    />
                  </a>
                </li>
              </ul>

              <button className="btnborder spacehead clr" type="button">
                <p className="fs-16 m-0">
                  {clientData?.firstName} {clientData?.middleName}{" "}
                  {clientData?.lastName}
                </p>
              </button>
              <div className="user-circle  text-danger border-danger spacehead clr ms-3" type="button"
                title="Logout"
                onClick={handleLogout}
                style={{ cursor: "pointer" }}
              >

                <FaPowerOff />
              </div>


            </div>
          </div>
        </nav>
      </header>

      {showCalendar && (
        <div className="calendar-container fullcalendar-container" ref={calendarRef}>


          <CalendarView events={formattedEvents} datesSet={handleDatesSet} />
        </div>
      )}




      <style>
        {`
  .calendar-container {
    position: absolute;
    background: #ffffff;
    border-radius: 12px;
    padding: 16px;
    z-index: 1000;
    width: 95%;
    max-width: 1000px;
    color: black;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease-in-out;
    overflow-x: auto;
  }

  .fullcalendar-container {
    width: 100%;
  }

  .dark-mode .calendar-container {
    background: #23674b;
    color: white;
  }

  /* FullCalendar Theming */
  .fc .fc-toolbar-title {
    color: #23674b;
    font-size: 1.4rem;
    font-weight: 600;
  }

  .fc-button {
    background-color: #23674b !important;
    border: none !important;
    color: white !important;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    transition: background 0.2s ease-in-out;
  }

  .fc-button:hover,
  .fc-button:focus {
    background-color: #1b513a !important;
    box-shadow: none !important;
  }

  .fc-daygrid-day-number {
    color: #23674b;
    font-weight: 500;
    padding: 4px;
  }

  .fc .fc-col-header-cell-cushion {
    color: #23674b;
    font-weight: 600;
    padding: 6px;
  }

  .fc .fc-daygrid-day.fc-day-today {
    background: #e8f5f0;
    border-radius: 6px;
  }

  /* Dark Mode Adjustments */
  .dark-mode .fc .fc-toolbar-title,
  .dark-mode .fc-daygrid-day-number,
  .dark-mode .fc .fc-col-header-cell-cushion {
    color: #ffffff;
  }

  .dark-mode .fc .fc-daygrid-day.fc-day-today {
    background: #1b513a;
  }

  /* Responsive Calendar Position */
  @media (min-width: 1200px) {
    .calendar-container {
      top: 90px;
      right: 180px;
    }
  }

  @media (min-width: 768px) and (max-width: 1199px) {
    .calendar-container {
    
      top: 80px;
      right: 100px;
    }
  }

  @media (max-width: 767px) {
    .calendar-container {
      top: 70px;
      right: 0px;
      padding: 12px;
    }

    .fc .fc-toolbar-title {
      font-size: 1rem;
    }

    .fc-button {
      padding: 4px 8px;
      font-size: 12px;
    }

    .fc .fc-col-header-cell-cushion,
    .fc-daygrid-day-number {
      font-size: 12px;
    }
  }
`}
      </style>



    </>
  );
};

function setCookie(key, value, expiryDays) {
  const expires = new Date();
  expires.setTime(expires.getTime() + expiryDays * 24 * 60 * 60 * 1000);
  document.cookie = `${key}=${value};expires=${expires.toUTCString()};path=/`;
}

function getCookie(key) {
  const keyValue = document.cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
  return keyValue ? keyValue[2] : null;
}

export default Navbar;
